import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Main from 'landing/layouts/Main';
import Container from 'components/Container';
import Login from './components/Login';

const LoginPage = () => {
  const theme = useTheme();

  return (
    <Main>
      <Box
        sx={{
          background: theme.palette.darkGrey[25],
        }}
      >
        <Container
          paddingTop={{ xs: '64px !important', md: '191px !important' }}
          paddingBottom={{ xs: '64px !important', md: '191px !important' }}
        >
          <Login />
        </Container>
      </Box>
    </Main>
  );
};

export default LoginPage;
